import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../../util/Axios';
import { Box, Stack } from '@mui/material';
import { PublicHeader } from '../../components/PublicHeader';
import { ResultCard } from './Components/ResultCard';
import { NeglectTest } from './Components/NeglectTest';
import { GazeTest } from './Components/Gaze/GazeTest';
import { FaceTest } from './Components/FaceTest';
import { SpeechTest } from './Components/SpeechTest';
import { ArmTest } from './Components/ArmTest';
import { TestHeader } from './Components/TestHeader';

export function TestReviewPage() {
  const [testDetails, setDetails] = useState({});
  let { testId } = useParams();
  const [video, setVideo] = useState([]);

  useEffect(() => {
    axios(`ems/strokeTests/${testId}`).then((resp) => {
      setDetails(resp.data);
      if (resp.data?.videoUrl) {
        axios('/ems/strokeTests/' + testId + '/video', { responseType: 'blob' }).then((response) => setVideo(window.URL.createObjectURL(response.data)));
      } else {
        setVideo(null);
      }
    });
  }, [testId]);

  return (
    <>
      <PublicHeader />
      <Box sx={{ paddingTop: '54px' }}>
        <Stack direction="column" spacing={2} padding="50px">
          <TestHeader testDetails={testDetails} />
          <Stack direction="row" spacing={2} justifyContent="center">
            <ResultCard title="FACE">{testDetails && <FaceTest testDetails={testDetails} video={video} />}</ResultCard>
            <ResultCard title="SPEECH">
              <SpeechTest testDetails={testDetails} />
            </ResultCard>
          </Stack>
          <Stack direction="row" spacing={2} justifyContent="center">
            <ResultCard title="NEGLECT">
              <NeglectTest testDetails={testDetails} />
            </ResultCard>
            <ResultCard title="GAZE">
              <GazeTest testDetails={testDetails} />
            </ResultCard>
          </Stack>
          <Stack direction="row" spacing={2} justifyContent="center">
            <ResultCard title="LEFT ARM">{testDetails?.armsResult && <ArmTest armResult={testDetails.armsResult.leftArmResult} armsPitchData={testDetails.armsPitch?.leftArmData} />}</ResultCard>
            <ResultCard title="RIGHT ARM">{testDetails?.armsResult && <ArmTest armResult={testDetails.armsResult.rightArmResult} armsPitchData={testDetails.armsPitch?.rightArmData} />}</ResultCard>
          </Stack>
        </Stack>
      </Box>
    </>
  );
}
